import { Component, Input, OnInit } from '@angular/core';
import { CommunicationService } from 'app/_services/communication.service';
import { AppComponent } from 'app/app.component';
import { ISettings } from 'app/_models/ISettings';
import { IconDefinition, faGear, faBell, faArrowUpRightFromSquare, 
  faGauge, faArrowUpFromBracket, faRightFromBracket, faGroupArrowsRotate
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'user-menu-component',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.css']
})
export class UserMenuComponent implements OnInit {  
  //#region Fields & Icons
  @Input() settings: ISettings;
  @Input() username: string;
  @Input() userRole: string;
  @Input() greeting: string;
  @Input() mobileView: boolean = false;  
  @Input() dashboardCarouselList: any[] = [];
  openCarouselList: boolean = false;
  faGear: IconDefinition = faGear;
  faBell: IconDefinition = faBell;
  faArrowUpRightFromSquare: IconDefinition = faArrowUpRightFromSquare;
  faGauge: IconDefinition = faGauge;
  faArrowUpFromBracket: IconDefinition = faArrowUpFromBracket;
  faRightFromBracket: IconDefinition = faRightFromBracket;
  faGroupArrowsRotate: IconDefinition = faGroupArrowsRotate;
  //#endregion

  constructor(
    public app: AppComponent,
    private communicationService: CommunicationService
  ) { }

  ngOnInit(): void { }

  openSettings(): void {
    this.communicationService.closeUserMenu(false);
    this.communicationService.showSettingsDialog();
  }

  openNotifications(): void {
    this.communicationService.closeUserMenu(false);
    this.communicationService.showNotificationsDialog();
  }

  newReport(): void {
    this.communicationService.closeUserMenu(false);
    sessionStorage.removeItem('reportId');
    this.app.cookieService.set('reportOpenedFromMenu', 'true');
    window.open('report-designer', '_blank');
  }

  newDashboard(): void {
    this.communicationService.closeUserMenu(false);
    sessionStorage.removeItem('dashboardId');
    localStorage.removeItem('qx_dashboard');
    window.open('dashboard-designer', '_blank');
  }

  openFileImport(): void {
    this.communicationService.closeUserMenu(false);
    this.communicationService.showImportFileDialog();
  }
  
  logout(): void {    
    this.communicationService.closeUserMenu(true);
  }

  openCookiePolicy(): void {
    this.communicationService.closeUserMenu(false);
    window.open('/assets/cookies.html');
  }  

  openDashboardCarousel(carouselId: number): void {
    this.communicationService.closeUserMenu(false);
    sessionStorage.setItem('qx_carousel_Id', carouselId.toString());
    window.open('dashboard-carousel', '_blank');
  }
}